import { useMutation } from '@tanstack/react-query';

import { TypeRequestHeaders, axiosInstance } from '~/services/fetchServiceV2';
import { TypeCodeState } from '~/types';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeModifyUserInfoParams = {
  /** 주민등록번호 */
  juminNo?: string;
  /** 우편번호 */
  postCode?: string;
  /** 주소 */
  address?: string;
  /** 상세주소 */
  detailAddress?: string;
  /** 은행코드 */
  financialInstitution?: string;
  /** 계좌번호 */
  accountNo?: string;
};

export type TypeModifyUserInfoResponse = {
  code: string;
  message: string;
  data: {
    juminNo: string;
    maskedJuminNo: string;
    postCode: string;
    address: string;
    detailAddress: string;
    financialInstitution: TypeCodeState;
    accountNo: string;
    maskedAccountNo: string;
    accountName: string;
    completedPrivacyInfo: boolean;
  } | null;
};

/**
 * @description 개인정보 수정 api 요청에 사용되는 커스텀 훅
 */
export const useModifyUserInfo = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeModifyUserInfoParams & { headers?: TypeRequestHeaders }) => {
      const endpoint = '/labor-accounts/my-info';
      return axiosInstance.put(endpoint, params, { headers: params.headers });
    },
  });

  const requestModifyUserInfo = async ({
    params,
    headers,
    onSuccess,
    onError,
  }: {
    params: TypeModifyUserInfoParams;
    headers?: TypeRequestHeaders;
    onSuccess?: (res: TypeModifyUserInfoResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync({ ...params, headers }), onSuccess, onError);
  };

  return requestModifyUserInfo;
};
